export const refreshTokenUrlName = 'SessionManagement';
interface PlatformService {
    name: string;
    url: string;
}

export interface Session {
    sessionId: string;
    sessionType: any;
}

export interface User {
    loggedInUserId: any;
    roleType: any;
}

export interface Device {
    scannerModel: any;
    scannerVersion: any;
    scannerSerial: any;
    scannerResGuid: any;
    wandSerial: any;
}

export interface BizCtx {
    contactId: any;
    companyId: any;
    region: any;
    patientId: any;
    orderId: string;
    csmMessageId: string;
    rxid: any;
}

export interface UI {
    dateFormat: any;
    languague: string;
}

export interface Security {
    accessToken: string;
}

export interface ITeroCtx {
    session: Session;
    user: User;
    device: Device;
    bizCtx: BizCtx;
    UI: UI;
    security: Security;
    platformServices: Array<PlatformService>;
}
export const getRefreshTokenUrl = (platformServices: Array<PlatformService>) => {
    return platformServices?.find(x => x?.name === refreshTokenUrlName)?.url;
};